import axios from "axios";
import Vue from "vue";

export const presQuestion2022Mixin = {
    created: function () {
        this.qOrder = window.questionsOrder;
        this.qCount = window.questionCount;
        this.recaptchaKey = recaptchaKey;

        const _self = this;
        window.sendAnswers = function (token) {
            _self.sendUserAnswers(token);
        };
    },
    mounted: function () {
        this.loadRecaptcha();
    },
    methods: {
        loadRecaptcha() {
            Vue.nextTick(() => {
                if (window.grecaptcha) {
                    grecaptcha.render("recaptcha");
                }
            });
        },
        nextQuestion: function () {
            const _self = this;
            Vue.nextTick(() => {
                if (_self.qCount != _self.actualQuestionIndex) {
                    return _self.actualQuestionIndex++;
                } else {
                    _self.finish();
                }
            });
        },
        prevQuestion: function () {
            const _self = this;
            Vue.nextTick(() => {
                return _self.actualQuestionIndex--;
            });
        },
        reset: function () {
            this.q = [];
            this.gameResponse = {};
            this.isFinished = false;
            this.actualQuestionIndex = 0;
            this.name = null;
            this.acceptQuestionTerms = false;
        },
        finish: function () {
            grecaptcha.execute();
        },
        sendUserAnswers: function (token) {
            const _self = this;
            const dat = {
                name: this.name,
                answers: Object.entries(this.q).map(a => {
                    return {
                        question: a[0],
                        answer: a[1]
                    }
                })
            };
            axios.post('/api/elections/pres-game-2022', dat, {
                    headers: {
                        RecaptchaResponse: token,
                    },
                }).then(resp => {
                    _self.gameResponse = resp.data
                    this.isFinished = true;
                })
                .catch(function (error) {
                    grecaptcha.reset();
                    if (_self.recaptchaRetries < 2) {
                        grecaptcha.execute();
                    }
                    _self.recaptchaRetries++;
                });
        },
        openTermsModal: function () {
            this.termsModalOpened = true;
            document.body.classList.add("overflow-hidden");
        },
        closeTermsModal: function () {
            this.termsModalOpened = false;
            document.body.classList.remove("overflow-hidden");
        }
    },
    data: function () {
        return {
            termsModalOpened: false,
            acceptQuestionTerms: false,
            actualQuestionIndex: 0,
            qCount: 0,
            isFinished: false,
            q: {},
            name: null,
            qOrder: [],
            gameResponse: {},
            recaptchaRetries: 0
        };
    }
};